'use strict';

var updateHeader = status => {
    var $headerNav = $('.header-nav');
    var $headerPromo = $('.header-banner');

     var isPDP = $('.js-product-detail-page').length;

    if (isPDP) {
        $('header').removeClass('sticky-header fixed-header-enhanced');
        $headerNav.removeClass('fixed');
        $headerPromo.removeClass('fixed');
        $headerPromo.css({position: 'absolute'});
        return;
    }

    if (status === 'fixed') {
        $headerNav.addClass('fixed');
        $headerPromo.addClass('fixed');
    } else {
        $headerNav.removeClass('fixed pdp-header-hidden');
        $headerPromo.removeClass('fixed');
    }
};

module.exports = function() {

    // Fix/unfix header to top of screen, dependent on class added by custom preference
    // Note: This is intentionally not using utilities/scroll.js so that it can fix immediately vs. being debounced.
    // Should be replaced with CSS position:sticky once IE11 support is dropped.
    var hasFixedEnhancedHeader = $('header').hasClass('fixed-header-enhanced');
    var hasFixedHeader = $('header').hasClass('fixed-header');

    $(window).scroll(event => {
        var isPDP = $('.js-product-detail-page').length;

        if (isPDP && !window.isMobile()) {
            var $headerNav = $('.header-nav');
            var $headerPromo = $('.header-banner');
            var $pdTabs = $('.pd-tabs-nav');

            var scrollTop = $(event.target).scrollTop();
            var headerBannerHeight = $headerPromo.length ? $headerPromo.outerHeight() : 0;

            if (scrollTop > headerBannerHeight) {
                $headerNav.addClass('fixed');
            } else {
                $headerNav.removeClass('fixed pdp-header-hidden');
            }

            if ($pdTabs.length) {
                var tabsTop = $pdTabs[0].getBoundingClientRect().top;
                var headerNavBottom = $headerNav.hasClass('fixed')
                    ? $headerNav[0].getBoundingClientRect().bottom
                    : 0;

                if (tabsTop <= headerNavBottom) {
                    $headerNav.addClass('pdp-header-hidden');
                } else {
                    $headerNav.removeClass('pdp-header-hidden');
                }
            }

            $headerPromo.removeClass('fixed');
            return;
        }

        if (hasFixedHeader) {
            var $headerBanner = $('.header-banner');
            var headerBannerHeight = $headerBanner.length ? $headerBanner.outerHeight() : 0;
            var scrollTop = $(event.target).scrollTop();

            if (scrollTop > headerBannerHeight) {
                updateHeader('fixed');
            } else {
                updateHeader('unfixed');
            }
        }

        if (hasFixedEnhancedHeader) {
            var $headerBanner = $('.header-banner');
            var $headerNav = $('.header-nav');
            var headerBannerHeight = $headerBanner.length ? $headerBanner.outerHeight() : 0;
            var headerNavHeight = $headerNav.length ? $headerNav.outerHeight() : 0;

            var scrollTop = $(event.target).scrollTop();
            var isMobile = window.isMobile();
            var target = isMobile ? 10 : headerNavHeight;

            if (scrollTop > target) {
                updateHeader('fixed');
            } else {
                updateHeader('unfixed');
            }
        }
    });

    var isMobile = window.isMobile();

    if ($('header').hasClass('transparent-header') && !isMobile) {
        $('.header-nav').hover(
            function() {
                $(this).removeClass('transparent-nav');
            },
            function() {
                $(this).addClass('transparent-nav');
            }
        );
    }

    // Check for presence of content assets in MegaMenu
    var $megamenuDropdown = $('.megamenu > .dropdown-menu');

    $megamenuDropdown.each((index, element) => {
        var $megamenu = $(element);

        if ($megamenu.find('.megamenu-asset-1').children().length) {
            $megamenu.addClass('has-asset-1');
        }

        if ($megamenu.find('.megamenu-asset-2').children().length) {
            $megamenu.addClass('has-asset-2');
        }
    });

    // Show/hide content assets on mobile based on category level
    if (isMobile) {
        var $thirdMenuBackBtn = $('.megamenu .menu-subcategories > .dropdown-item');
        var $thirdSubLink = $('.megamenu .menu-subcategories > .dropdown-item > .dropdown-link');

        $thirdSubLink.on('click', function () {
            $('.megamenu.show .menu-subcategories').parent('li').addClass('thirdCatOpen');
        });

        $thirdMenuBackBtn.on('click', function () {
            $('.megamenu.show .menu-subcategories').parent('li').removeClass('thirdCatOpen');
        });
    }

    $('.main-menu .navbar-nav').on('mouseenter mouseleave', function () {
        $(this).toggleClass('nav-item-hover');
    });

    $('.menu-level-1 .nav-item').on('mouseenter', function () {
        $('.custom-select').blur();
    });

    $('.menu-level-1 .nav-item').on('mouseleave', function () {
        $('.modal-background').hide();
    });

    $('header .site-search').on('mouseenter', event => {
        var $siteSearch = $(event.target).closest('.site-search');
        $siteSearch.addClass('expanded');
    });

    $('header .site-search').on('mouseleave', event => {
        var $siteSearch = $(event.target).closest('.site-search');
        var $input = $siteSearch.find('input');

        if (!$input.is(':focus') && !$input.val()) {
            $siteSearch.removeClass('expanded');
        }
    });

    $('form[name=simpleSearch]').on('submit', event => {
        var $form = $(event.target);
        var $input = $('input[name=q]', $form);

        if ($input.val() == "") {
            $input.focus();
            event.preventDefault();
        }
    });
};